import './LBPageNav.style.less'

import { useLocation, useNavigate } from 'react-router-dom'
import { Button } from 'antd'
import { first } from 'lodash'
import { useEffect } from 'react'
import { useAuth } from '@/providers/auth.provider'

interface Prop {
  config: any
}

function LBPageNav({ config }: Prop) {
  const { user } = useAuth()
  const routes: any[] = config?.company?.modules?.map((item) => item) || []
  const location = useLocation()
  const navigate = useNavigate()

  const allRoutes = [...routes]

  useEffect(() => {
    if (routes.length > 0) {
      if (
        location.pathname === '/liveboard/' ||
        location.pathname === '/liveboard'
      )
        navigate(first(routes))
    }
  }, [location])

  return (
    <div className={'liveboard-navigation-button-container'}>
      {allRoutes?.map((item) => {
        return (
          <Button
            onClick={() => navigate(`/liveboard/${item.key}`)}
            className={
              location.pathname.toLowerCase() ==
              `/liveboard/${item.key.toLowerCase()}`
                ? 'selected-button'
                : ''
            }
            size="large"
            key={item.key}
          >
            {item.name}
          </Button>
        )
      })}
    </div>
  )
}

export default LBPageNav
